var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16887 19.8499C4.73291 19.5438 5.41924 19.571 5.95731 19.9207L28.3369 34.4675L50.7165 19.9207C51.2546 19.571 51.9409 19.5438 52.505 19.8499C53.069 20.156 53.4202 20.7463 53.4202 21.388V46.8426C53.4202 49.0684 51.7323 51.138 49.3369 51.138H7.33691C4.94153 51.138 3.25358 49.0684 3.25358 46.8426V21.388C3.25358 20.7463 3.60483 20.156 4.16887 19.8499ZM6.75358 24.6127V46.8426C6.75358 47.4283 7.15497 47.638 7.33691 47.638H49.3369C49.5189 47.638 49.9202 47.4283 49.9202 46.8426V24.6127L29.2906 38.022C28.7107 38.3989 27.9631 38.3989 27.3832 38.022L6.75358 24.6127Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3438 3.61376C27.9418 3.20166 28.7321 3.20166 29.33 3.61376L52.6633 19.695C53.4591 20.2435 53.6596 21.3332 53.1112 22.129C52.5627 22.9248 51.473 23.1253 50.6772 22.5769L28.3369 7.18005L5.99666 22.5769C5.20086 23.1253 4.11111 22.9248 3.56265 22.129C3.01418 21.3332 3.21469 20.2435 4.0105 19.695L27.3438 3.61376Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailOpen);
export default __webpack_public_path__ + "static/media/mail-open.d996b735.svg";
export { ForwardRef as ReactComponent };